import { Component, Input, OnInit } from '@angular/core';
import { UserCollectionsServices } from 'src/app/providers/user-collection-services';
import { Browser } from '@capacitor/browser';
import { addIcons } from 'ionicons';
import { rocketOutline } from 'ionicons/icons';
import { NgIf } from '@angular/common';
import { IonButton, IonIcon, IonLabel } from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-advertizing-prize',
  standalone : true,
  templateUrl: './advertizing-prize.component.html',
  styleUrls: ['./advertizing-prize.component.scss'],
  imports: [NgIf, IonButton, IonIcon, IonLabel, TranslatePipe],
})
export class AdvertizingPrizeComponent implements OnInit {
  @Input() isVisible = false;
  @Input() prizeImage = '';
  @Input() prizeDescription = '';
  @Input() prizeURL = '';
  @Input() prizeURLText = '';
  @Input() advertizementCfgPrizeId = ''; // exme_mkt_cfg_col_prize_id
  @Input() advertizementPrizeLogId = ''; //exme_mkt_col_prize_log_id
  @Input() agentId;

  constructor(private userColectionsService: UserCollectionsServices) {
    addIcons({ rocketOutline });
  }

  ngOnInit() {}

  public async openPrizeWithSystemBrowser(url: string) {
    // eslint-disable-next-line max-len
    console.log(
      'Logging Click for: AgentId=' +
        this.agentId +
        ' advertizementCfgPrizeId=' +
        this.advertizementCfgPrizeId +
        ' advertizementPrizeLogId=' +
        this.advertizementPrizeLogId
    );
    console.log('url:' + url);
    // this.userColectionsService
    //   .notifyPrizeClick(
    //     this.agentId,
    //     this.advertizementCfgPrizeId,
    //     this.advertizementPrizeLogId
    //   )
    //   .subscribe((res) => {
    //     Browser.open({ url: url });
    //   });

    try {
      const res: any = await this.userColectionsService.notifyPrizeClick(this.agentId,this.advertizementCfgPrizeId,this.advertizementPrizeLogId);
      Browser.open({ url: url });
    } catch (error) {
      console.log(error);
    }
  }

  closePrize() {
    this.isVisible = false;
  }
}
